import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  avatarArea: {
    display: 'flex',
    alignItems: 'center'
  },

  lastSeen: {
    marginTop: '0.15rem',
    fontSize: theme.size.sm
  },

  label: {
    opacity: '0.5'
  },

  time: {
    fontStyle: 'italic',
    paddingLeft: '2px'
  },

  toolTipTime: {
    opacity: '0.8'
  },

  name: {
    marginBottom: '0.25rem'
  },

  container: {
    margin: '0.25rem 0'
  },

  online: {
    color: ({ online }) =>
      online === 'online' ? theme.palette.online : theme.palette.away,
    opacity: 1
  },

  faded: {
    opacity: '0.4'
  },

  count: {
    display: 'flex',
    marginLeft: '0.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.textLight,
    opacity: '0.55',

    '& .number': {
      fontSize: theme.size.sm,
      marginRight: '0.15rem'
    },

    '& .icon': {
      fontSize: theme.size.base
    }
  },

  type: {
    opacity: '0.4',
    color: theme.palette.textLight,
    fontSize: theme.size.sm,
    marginLeft: '0.5rem'
  },

  names: {
    maxWidth: '10rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: theme.size.sm
  },

  tooltip: {
    maxHeight: '65svh',
    padding: '0.25rem 0.75rem',
    overflowY: 'auto'
  }
}))

export default useStyles
